interface DateProps {
  localeTH?: boolean | null,
  symbol?: string | null,
}

interface DateFormat {
  toDateInt(): number | null,
  toDateLong(): string | null,
  toDateShort(): string | null,
  toDateTimeLong(obj?: DateProps): string | null,
  toDateTimeShort(obj?: DateProps): string | null,
  toTime(): string | null,
}

interface DateInt {
  en(): number | null
  th(): number | null
}

// const isIsoDate = (dateISO: string): boolean => {
//   if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d+(Z|[+|-]?\d{2}:\d{2})$/.test(dateISO)) return false;
//   const date = new Date(dateISO);
//   return date instanceof Date && !Number.isNaN(date.getTime());
// };

// const dateFormat = (dateISO: string, locale?: string): DateFormat => {
//   if (!isIsoDate(dateISO)) {
//     return {
//       toDateLong: () => null,
//       toDateShort: () => null,
//       toDateTimeLong: () => null,
//       toDateTimeShort: () => null,
//       toTime: () => null,
//     };
//   }

//   const loc = locale ?? 'th-TH';
//   const isTH = loc === 'th-TH';
//   const date = new Date(dateISO);
//   const dateLong = date.toLocaleString(loc, { year: 'numeric', month: 'long', day: 'numeric' });
//   const dateShort = date.toLocaleString(loc, { year: 'numeric', month: 'numeric', day: 'numeric' });
//   const time = date.toLocaleString(loc, { hour: 'numeric', minute: 'numeric', second: 'numeric' });
//   return {
//     toDateLong: () => `${dateLong}`,
//     toDateShort: () => `${dateShort}`,
//     toDateTimeLong: (obj?: DateProps) => `${dateLong}${obj?.symbol ?? ' - '}${time}${(obj?.localeTH ?? isTH) ? ' น.' : ''}`,
//     toDateTimeShort: (obj?: DateProps) => `${dateShort}${obj?.symbol ?? ' - '}${time}${(obj?.localeTH ?? isTH) ? ' น.' : ''}`,
//     toTime: () => time,
//   };
// };

const isValidDate = (date: any) => date instanceof Date && !isNaN(+date);

const isIsoDate = (dateISO: string): boolean => {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d+(Z|[+|-]?\d{2}:\d{2})$/.test(dateISO)) return false;
  const date = new Date(dateISO);
  return date instanceof Date && !Number.isNaN(date.getTime());
};

const toDateInt = (date: Date): DateInt => ({
  en: () => {
    const mmddyyyy = date.toLocaleString('en-US');
    const dates = mmddyyyy.split('/');
    try {
      return +`${dates[2].split(',')[0]}${dates[0].padStart(2, '0')}${dates[1].padStart(2, '0')}`;
    } catch (error) {
      return null;
    }
  },
  th: () => {
    const ddmmyyyy = date.toLocaleString('th-TH');
    const dates = ddmmyyyy.split('/');
    try {
      return +`${dates[2]}${dates[1].padStart(2, '0')}${dates[0].padStart(2, '0')}`;
    } catch (error) {
      return null;
    }
  },
});

// const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

// const getCurrentDate = (): Date => new Date();

export const dateFormat = (d: string | Date, locale?: string): DateFormat => {
  const date: Date = d instanceof Date ? d : new Date(d);
  if (typeof d === 'string') {
    if (!(isIsoDate(d)) && !isValidDate(date)) {
      return {
        toDateInt: () => null,
        toDateLong: () => null,
        toDateShort: () => null,
        toDateTimeLong: () => null,
        toDateTimeShort: () => null,
        toTime: () => null,
      };
    }
  }

  locale = locale ?? 'th-TH';
  const isTH = locale === 'th-TH';
  const dateLong = date.toLocaleString(locale, { year: 'numeric', month: 'long', day: 'numeric' });
  const dateShort = date.toLocaleString(locale, { year: 'numeric', month: 'numeric', day: 'numeric' });
  const time = date.toLocaleString(locale, { hour: 'numeric', minute: 'numeric', second: 'numeric' });

  return {
    toDateInt: () => toDateInt(date).th(),
    toDateLong: () => `${dateLong}`,
    toDateShort: () => `${dateShort}`,
    toDateTimeLong: (obj?: DateProps) => `${dateLong}${obj?.symbol ?? ' - '}${time}${(obj?.localeTH ?? isTH) ? ' น.' : ''}`,
    toDateTimeShort: (obj?: DateProps) => `${dateShort}${obj?.symbol ?? ' - '}${time}${(obj?.localeTH ?? isTH) ? ' น.' : ''}`,
    toTime: () => time,
  };
};

export default dateFormat;
